import { fetchData } from "./fetch";

export const getProfiles = (data) => fetchData('GET', '/profiles', data);

export const createProfile = (data) => fetchData('POST', '/profiles', data);

export const removeProfile = (id) => fetchData('DELETE', `/profiles/${id}`);

export const updateProfile = ({ id, data }) => fetchData('PUT', `/profiles/${id}`, data);
